import React from 'react';
import { Typography, Space, Button, Flex } from 'antd';

import { PointInTime } from '~components/PointInTime';
import RenderedHtml from './RenderedHtml';

type PriceUpdate2026NotificationProps = {
  notification: {
    description: string;
    createdAt: string;
    metadata?: {
      htmlContent?: string;
      link?: string;
    };
  };
};

function PriceUpdate2026Notification({ notification }: PriceUpdate2026NotificationProps) {
  const { metadata = {} } = notification;

  return (
    <Space direction="vertical" size="large">
      <Typography.Text strong>
        <PointInTime value={notification.createdAt} />
      </Typography.Text>
      <Flex vertical>
        <Typography.Title level={4}>Pricing update</Typography.Title>
        <Typography.Title level={3}>{notification.description}</Typography.Title>
      </Flex>

      <RenderedHtml html={metadata.htmlContent} />

      {metadata.link && (
        <Typography.Link target="_blank" rel="noreferrer" href={metadata.link}>
          <Button type="primary">See the full details</Button>
        </Typography.Link>
      )}
    </Space>
  );
}

export default PriceUpdate2026Notification;
